import { EVALUATION_ROUNDS } from '@/types/enums';

export const ASSESSMENT_ROUND_FILTER_VALUE = 'assessment_round';
export const ASSESSMENT_ROUND_FILTER_LABEL = 'MCQ/Open Ended';
export const ASSESSMENT_ROUND_FILTER_ROUNDS = [
  EVALUATION_ROUNDS.MCQ,
  EVALUATION_ROUNDS.OPEN_ENDED,
] as const;
